



















































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { OrderToAdmResp_Order, UpdateOrderReq, File, DeleteFileReq_FileType, UpdateOrderReq_Order } from '@/apiv3/index'
import auth from '@/auth'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import helpers from '@/helpers'
import VueUploadComponent from 'vue-upload-component'
import { FileStatus } from '@/api'

@Component({ components: { PulseLoader, VueUploadComponent } })
export default class OrderEdit extends Vue {
  @Prop(String) id!: string

  public order!: OrderToAdmResp_Order
  public blocked = false
  public loaded = false
  public finishDate = ''
  public DeleteFileReq_FileType = DeleteFileReq_FileType
  public files: Array<VUFile> = []
  public workFiles: Array<File> = []
  public orderFiles: Array<File> = []

  $refs!: {
    upload: VueUploadComponent;
  }

  public inputFile (newFile: VUFile, oldFile: VUFile) {
    if (Boolean(newFile) !== Boolean(oldFile)) {
      this.$refs.upload.active = true
    }
  }

  public removeFileOrder (file: VUFile) {
    this.$refs.upload.remove(file)
  }

  public uploadChunk (): object {
    const headers = {
      Token: auth.adminToken()
    }

    const res = {
      action: 'https://prepodam.ru/api/v2/file',
      minSize: 1,
      maxActive: 3,
      maxRetries: 5,
      headers: headers
    }

    return res
  }

  mounted () {
    const id = helpers.getAmount(this.id)
    auth.adminClient().OrderToAdm({ id: BigInt(id) }).then((resp) => {
      if (resp.order) {
        this.order = resp.order
        this.finishDate = helpers.dateTsToInputValue(resp.order.finishDate)
        this.workFiles = this.order.workFiles
        this.orderFiles = this.order.orderFiles
        this.loaded = true
      }
    })
  }

  formatDate (val: string | undefined): string {
    return helpers.formatDate(val)
  }

  updateOrder () {
    if (this.order === undefined) {
      return
    }

    this.blocked = true

    this.order.finishDate = helpers.inputValueToDateTs(this.finishDate)

    const files: bigint[] = []

    this.files.forEach((_value: VUFile, index: number) => {
      const resp = this.$refs.upload.files[index.valueOf()].response as FileStatus
      files.push(BigInt(resp.id))
    })

    const order: UpdateOrderReq_Order = {
      number: this.order.number,
      type: this.order.type,
      lesson: this.order.lesson,
      theme: this.order.theme,
      demand: this.order.demand,
      size: this.order.size,
      price: this.order.price,
      userId: this.order.userId,
      economics: this.order.economics,
      humanitary: this.order.humanitary,
      juridas: this.order.juridas,
      languages: this.order.languages,
      technology: this.order.technology,
      deleted: this.order.deleted,
      orderFiles: files,
      finishDate: this.order.finishDate
    }

    const req: UpdateOrderReq = {
      id: BigInt(helpers.getAmount(this.id)),
      order: order
    }

    auth.adminClient().UpdateOrder(req).then(() => {
      this.$router.push('/adm/')
    }).finally(() => {
      this.blocked = false
    })
  }

  public getFileURL (file: File, ord: OrderToAdmResp_Order | undefined): string {
    return helpers.getFileURL(file, ord)
  }

  removeFile (fileId: bigint, fileIdx: number, type: DeleteFileReq_FileType) {
    auth.adminClient().DeleteFile({ id: fileId, orderId: BigInt(helpers.getAmount(this.id)), type: type }).then(() => {
      if (type === DeleteFileReq_FileType.WORK) {
        this.workFiles.splice(fileIdx, 1)
      } else {
        this.orderFiles.splice(fileIdx, 1)
      }
    })
  }
}
